<template>
  <b-modal
    v-model="showModal"
    :title="$t('Configure Homework Days')"
    modal-class="modal-primary"
    hide-footer
    @hidden="hideModal"
  >
    <validation-observer ref="simpleRules" #default="{ invalid }">
      <b-form @submit.prevent="validationForm">
        <validation-provider name="Days" rules="required" v-slot="{ errors }">
          <b-form-group
            :label="$t('Available Days')"
            :state="errors[0] ? false : null"
          >
            <v-select
              :placeholder="$t('Select Days')"
              v-model="daysSelected"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :clearable="false"
              :closeOnSelect="false"
              label="name"
              :multiple="true"
              :options="days"
              :reduce="(option) => option.id"
            />
          </b-form-group>
        </validation-provider>

        <b-button
          block
          type="submit"
          variant="outline-primary"
          :disabled="invalid"
        >
          {{ $t("Save") }}
        </b-button>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
<script >
import DaysService from "@/views/users/views/list/services/days.service.js";

export default {
  name: "AttendanceAvailableDays",
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showModal: true,
      days: [],
      daysSelected: [],
    };
  },
  created() {
    this.getHomeworkDays();
    this.getDays();
  },
  methods: {
    hideModal() {
      this.showModal = false;
      this.$emit("hideModal");
    },
    async getDays() {
      try {
        const { data } = await DaysService.getDays();
        data.days.map((row) => {
          row.name = this.$t(row.name);
        });
        this.days = data.days;
      } catch (error) {
        this.showErrorSwal(e);
      }
    },
    async validationForm() {
      const isValid = await this.$refs.simpleRules.validate();
      if (isValid) {
        this.saveHomeworkDays();
      }
    },

    async saveHomeworkDays() {
      try {
        const response = await DaysService.saveHomeworkDays({
          days: this.daysSelected,
          user_id: this.user.id,
        });
        if (response.status === 200) {
          this.$swal({
            title: this.$t("Success"),
            text: this.$t("Homework Days Saved Successfully"),
            icon: "success",
          });
          this.hideModal();
        }
      } catch (error) {
        this.showErrorSwal(error);
      }
    },

    async getHomeworkDays() {
      try {
        const { data } = await DaysService.getHomeworkDays({
          user_id: this.user.id,
        });
        this.daysSelected = data.days.map((day) => day.day_id);
      } catch (error) {
        this.showErrorSwal(error);
      }
    },
  },
};
</script>